<template>
    <div class="app flex-row align-items-sm-center login-container-xs">
        <div class="container">
            <div class="row justify-content-center">
                <spinner v-if="loading"></spinner>
                <div v-else class="col-md-6">
                    <div class="card-group mb-0">
                        <div class="card px-4 pt-4">
                            <div class="card-body login-container">
                                <b-alert v-if="success" variant="success" :show="true" :key="'registration-submitted-success'" class="mt-5">
                                    {{ trans('messages.success.tenants.registration_submitted') }}
                                </b-alert>
                                <b-alert v-else variant="danger" :show="true" :key="'registration-submitted-error'" class="mt-5">
                                    {{ trans('messages.error.registration.error_occurred') }}
                                </b-alert>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import Spinner from '@/components/Loaders/Spinner';
    import RegisterController from '@/services/Auth/RegisterController';

    export default {

        components: { Spinner },

        created() {
            this.setPageTitle(this.trans('contacts.actions.register'));

            this.checkInvitation();
        },

        data() {
            return {
                loading: true,
                success: false
            };
        },

        methods: {
            checkInvitation() {
                RegisterController.showTenant(
                    this.$router.currentRoute.params.key,
                    this.$router.currentRoute.params.hash
                ).then(response => {
                    this.success = response.exists && response.status === 'answered';
                    this.loading = false;
                });
            }
        }

    };

</script>



// WEBPACK FOOTER //
// src/views/Auth/RegisterTenantDone.vue